import React, { PureComponent } from 'react';

import { toast } from 'react-toastify';

import AdBuilderCanvas from './AdBuilderCanvas';
import AdBuilderCollection from './AdBuilderCollection';
import AdBuilderCarousel from './AdBuilderCarousel';
import AdBuilderDAA from './AdBuilderDAA';
import AdBuilderVideo from './AdBuilderVideo';

import './AdBuilderBase.css';

class AdBuilderBase extends PureComponent {
  componentDidMount() {
    toast.configure();
  }
  render() {
    const {
      tags,
      user,
      accounts,
      canvases,
      adPrototypeEdit,
      adType,
      getFbToken,
      searchPage,
      updateAdPrototype
    } = this.props;

    return (
      <div>
        {adType === 'Canvas' ? (
          <AdBuilderCanvas
            user={user}
            searchPage={searchPage}
            tags={tags}
            accounts={accounts}
            canvases={canvases}
            getFbToken={getFbToken}
            adPrototypeEdit={adPrototypeEdit}
            updateAdPrototypeForQc={updateAdPrototype}
          />
        ) : null}
        {adType === 'Collection' ? (
          <AdBuilderCollection
            user={user}
            searchPage={searchPage}
            tags={tags}
            accounts={accounts}
            getFbToken={getFbToken}
            adPrototypeEdit={adPrototypeEdit}
            updateAdPrototypeForQc={updateAdPrototype}
          />
        ) : null}
        {adType === 'Carousel' ? (
          <AdBuilderCarousel
            user={user}
            searchPage={searchPage}
            tags={tags}
            accounts={accounts}
            getFbToken={getFbToken}
            adPrototypeEdit={adPrototypeEdit}
            updateAdPrototypeForQc={updateAdPrototype}
          />
        ) : null}
        {adType === 'DAA' ? (
          <AdBuilderDAA
            user={user}
            searchPage={searchPage}
            tags={tags}
            accounts={accounts}
            getFbToken={getFbToken}
            adPrototypeEdit={adPrototypeEdit}
            updateAdPrototypeForQc={updateAdPrototype}
          />
        ) : null}
        {['Video', 'Cinemagraph', 'Still'].includes(adType) ? (
          <AdBuilderVideo
            user={user}
            searchPage={searchPage}
            tags={tags}
            accounts={accounts}
            getFbToken={getFbToken}
            adPrototypeEdit={adPrototypeEdit}
            updateAdPrototypeForQc={updateAdPrototype}
          />
        ) : null}
      </div>
    );
  }
}

export default AdBuilderBase;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderBase.js